'use client';

import { useEffect, useRef, useState } from 'react';
import { Button } from 'reactstrap';

const COPIED_RESET_MS = 2000;

// Fallback for browsers or contexts without the async Clipboard API
// (plain-HTTP previews, older Safari): a hidden textarea + execCommand.
const legacyCopy = (text) => {
  const area = document.createElement('textarea');
  area.value = text;
  area.setAttribute('readonly', '');
  area.style.position = 'absolute';
  area.style.left = '-9999px';
  document.body.appendChild(area);
  area.select();
  let ok = false;
  try {
    ok = document.execCommand('copy');
  } catch {
    ok = false;
  }
  document.body.removeChild(area);
  return ok;
};

export const copyText = async (text) => {
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // Permission denied or insecure context: try the legacy path below.
    }
  }
  return legacyCopy(text);
};

function CopyButton({
  text, label = 'Copy', color = 'soft-primary', size = 'sm', className = '',
}) {
  const [state, setState] = useState('idle');
  const timer = useRef(null);

  useEffect(() => () => clearTimeout(timer.current), []);

  const onCopy = async () => {
    const ok = await copyText(text);
    setState(ok ? 'copied' : 'failed');
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setState('idle'), COPIED_RESET_MS);
  };

  let content = (
    <>
      <i className="uil uil-copy me-1" />
      {label}
    </>
  );
  if (state === 'copied') {
    content = (
      <>
        <i className="uil uil-check me-1" />
        Copied
      </>
    );
  } else if (state === 'failed') {
    content = 'Select and copy manually';
  }

  return (
    <Button type="button" color={color} size={size} className={className} onClick={onCopy}>
      {content}
    </Button>
  );
}

export default CopyButton;
